<div class="row">
  <div class="col-12 text-center">
    <img
      class="imgLogo"
      height="100"
      width="100"
      src="assets/images/logoBlack.svg"
    />
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>N&uacute;mero de Siniestro:&nbsp;</b></span>
    <span>{{ siniestro?.numeroSiniestro }}</span>
  </div>
  <div class="col-6">
    <span><b>Fecha de Vencimiento:&nbsp;</b></span>
    <span>{{ siniestro?.fechaVencimiento | date: "dd/MM/yyyy" }}</span>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>Observaciones:&nbsp;</b></span>
    <span>{{ siniestro?.observaciones }}</span>
  </div>
  <div class="col-6">
    <span><b>Observaciones del Repuestero:&nbsp;</b></span>
    <span>{{ siniestro?.observacionesDelRepuestero }}</span>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>Perito:&nbsp;</b></span>
    <span>{{ siniestro?.perito }}</span>
  </div>
  <div class="col-6">
    <span><b>Observaciones del Perito:&nbsp;</b></span>
    <span>{{ siniestro?.observacionesDelPerito }}</span>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <h3>Costos</h3>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>Importe de las Piezas:&nbsp;</b></span>
    <span>{{ siniestro?.importePiezas }}</span>
  </div>
  <div class="col-6">
    <span><b>Impuesto:&nbsp;</b></span>
    <span>{{ siniestro?.impuestoPiezas }}</span>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>Importe Total:&nbsp;</b></span>
    <span>{{ siniestro?.importeTotal }}</span>
  </div>
  <div class="col-6"></div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <h3>Aseguradora</h3>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>Aseguradora:&nbsp;</b></span>
    <span>{{ siniestro?.aseguradora?.empresa?.display }}</span>
  </div>
  <div class="col-6">
    <span><b>Raz&oacute;n Social:&nbsp;</b></span>
    <span>{{ siniestro?.aseguradoraRazonSocial }}</span>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <h3>Datos del Veh&iacute;culo</h3>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>Marca y Modelo:&nbsp;</b></span>
    <span>{{ siniestro?.vehiculo?.marcaModelo }}</span>
  </div>
  <div class="col-6">
    <span><b>Patente:&nbsp;</b></span>
    <span>{{ siniestro?.vehiculo?.patente }}</span>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>N&uacute;mero de Chasis:&nbsp;</b></span>
    <span>{{ siniestro?.vehiculo?.numeroChasis }}</span>
  </div>
  <div class="col-6">
    <span><b>A&ntilde;o:&nbsp;</b></span>
    <span>{{ siniestro?.vehiculo?.anio }}</span>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>Combustible:&nbsp;</b></span>
    <span>{{ siniestro?.vehiculo?.combustible }}</span>
  </div>
  <div class="col-6"></div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <h3>Datos del Taller</h3>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>Calle:&nbsp;</b></span>
    <span>{{ siniestro?.taller?.domicilioCalle }}</span>
  </div>
  <div class="col-6">
    <span><b>Altura del Taller:&nbsp;</b></span>
    <span>{{ siniestro?.taller?.domicilioAltura }}</span>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>Piso:&nbsp;</b></span>
    <span>{{ siniestro?.taller?.domicilioPiso }}</span>
  </div>
  <div class="col-6">
    <span><b>Timbre:&nbsp;</b></span>
    <span>{{ siniestro?.taller?.domicilioTimbre }}</span>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>Entre Calles:&nbsp;</b></span>
    <span>{{ siniestro?.taller?.domicilioEntreCalles }}</span>
  </div>
  <div class="col-6">
    <span><b>Localidad:&nbsp;</b></span>
    <span>{{ siniestro?.taller?.domicilioLocalidad }}</span>
  </div>
</div>
<div class="row">
  <div class="col-6">
    <span><b>Provincia:&nbsp;</b></span>
    <span>{{ siniestro?.taller?.domicilioProvincia }}</span>
  </div>
  <div class="col-6">
    <span><b>Zona:&nbsp;</b></span>
    <span>{{ siniestro?.taller?.zona?.descripcion }}</span>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <span><b>Observaciones del Taller:&nbsp;</b></span>
    <span>{{ siniestro?.taller?.observaciones }}</span>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <h3>Tel&eacute;fonos</h3>
  </div>
</div>
<div class="row">
  <div class="col-12" *ngFor="let telefono of siniestro?.taller?.telefonos">
    <span><b>N&uacute;mero:&nbsp;</b></span>
    <span>{{ telefono.telefono }}</span>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <h3>Cotizador</h3>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <span><b>Cotizador:&nbsp;</b></span>
    <span>{{ siniestro?.cotizador?.display }}</span>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <h3>Estados de venta</h3>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <span><b>Estado:&nbsp;</b></span>
    <span>{{ getEstados() }}</span>
  </div>
</div>
<div class="row mt-3">
  <div class="col-12">
    <h3>Piezas</h3>
  </div>
</div>
<div class="row">
  <div
    class="col-12 text-center"
    *ngIf="!siniestro?.piezas && siniestro?.piezas?.length !== 0"
  >
    <span> No hay piezas cargadas hasta el momento</span>
  </div>
  <div
    class="col-12"
    *ngIf="siniestro?.piezas && siniestro?.piezas?.length !== 0"
  >
    <table class="w-100">
      <thead>
        <th>Pieza</th>
        <th>Calidad</th>
        <th>Fecha de Entrega</th>
        <th>Importe</th>
        <th>Productos Relacionados</th>
      </thead>
      <tbody>
        <tr *ngFor="let pieza of siniestro?.piezas">
          <td>{{ pieza.descripcion }}</td>
          <td>{{ pieza.calidad }}</td>
          <td>{{ pieza.fechaVencimiento | date: "dd/MM/yyyy" }}</td>
          <td>{{ pieza.importe }}</td>
          <td>
            <div *ngFor="let detalle of pieza.detalles">
              {{
                detalle?.pedidoProductoStock
                  ? detalle.pedidoProductoStock.producto.numeroPieza +
                    " - " +
                    detalle.pedidoProductoStock.producto.descripcion +
                    " " +
                    detalle.pedidoProductoStock.producto.calidad
                  : detalle.productoStock.producto.numeroPieza +
                    " - " +
                    detalle.productoStock.producto.descripcion +
                    " " +
                    detalle.productoStock.producto.calidad
              }}
              {{ " x " + detalle?.unidades }}
              {{
                detalle?.importePresupuestado
                  ? " $ " + detalle?.importePresupuestado
                  : ""
              }}
              {{
                " - " + detalle?.pedidoProductoStock
                  ? detalle.pedidoProductoStock?.proveedor
                    ? detalle.pedidoProductoStock?.proveedor?.display
                    : ""
                  : detalle.productoStock?.proveedor
                  ? detalle.productoStock?.proveedor?.display
                  : ""
              }}
              {{
                detalle?.pedidoProductoStock
                  ? "[PARA PEDIR]"
                  : "[EN STOCK" +
                    (detalle.productoStock.posicion
                      ? "-" + detalle.productoStock.posicion
                      : "") +
                    "]"
              }}
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
